// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TvEaw","newExpiryDate":"styles_newExpiryDate__3OWfy","footer":"styles_footer__fLBDk"};